export interface Rollouts {
    [key: string]: boolean;
}

export const ROLLOUTS = {
    GRIZZLIES_TRADER_DETAILS_DISPLAYING: 'grizzlies_trader_details_displaying',
    QUALAS_NEW_LEVEL_SYSTEM_CONSUMERS_MIGRATION: 'qualas_new_level_system_consumers_migration',
    QUALAS_LOG_UNKNOWN_CRAWLERS_ON_SELLER_PAGE: 'qualas_log_unknown_crawlers_on_seller_page',
    ZEBRAS_HOURLY_RATES: 'zebras_hourly_rate',
    CHEETAHS_SELLER_ROLE_PAGE_RELEASE_TWO: 'cheetahs_seller_role_page_release_two',
    CHEETAHS_PROFESSIONS: 'cheetahs_professions',
    CHEETAHS_PROFESSIONS_BUYER_SIDE: 'cheetahs_professions_buyer_side',
    STARLINGS_BOOSTING_NEW_GIGS: 'starlings_boosting_new_gigs',
    STARLINGS_FIVERR_GO_FLOATING_CHAT: 'starlings_fiverr_go_floating_chat',
    STARLINGS_FIVERR_GO_INBOX: 'starlings_fiverr_go_inbox',
    CARIBOU_PORTFOLIO_ATTACHMENT_REPORT_ELIGIBILITY: 'caribou_portfolio_attachment_report_eligibility',
    COBRAS_OPEN_HOURLY_TO_MP: 'cobras_open_hourly_to_mp',
    PIGLETS_ENABLE_PRICE_UPFRONT: 'piglets_enable_price_upfront_display',
    QUALAS_SELLER_PAGE_WORLD_CUP_WINNER_ARGENTINA: 'qualas_seller_page_world_cup_winner_argentina',
    QUALAS_SELLER_PAGE_WORLD_CUP_WINNER_SPAIN: 'qualas_seller_page_world_cup_winner_spain',
};
